import { defineAction } from '~/prix'
import residenceImageCreateAction from './residenceImageCreate.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'

const residenceImageCreateDefinition = defineAction({
  ...residenceImageCreateAction,

  input: z.object({
    id: z.string().uuid(),
    residenceId: z.string(),
    description: z.string().nullish(),
    position: z.number(),
    createdAt: dateOrIsoString().nullish(),
    updatedAt: dateOrIsoString().nullish(),
    format: enumerated({
      png: 'PNG',
      jpg: 'JPG',
      webp: 'WEBP',
    }),
  }),
  output: z.object({
    uploadUrl: z.string().nullish(),
    publicUrl: z.string().nullish(),
  }),
})

export default residenceImageCreateDefinition
